<div class="header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <span>{{data.title}}</span>
  <button class="close" mat-button mat-dialog-close>X</button>
</div>
<div class="content">

  <div class="container">
    <table mat-table [dataSource]="filteredDataSource">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                        [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)"
                        [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container *ngFor="let col of columns">
        <ng-container matColumnDef="{{col.name}}">
          <th mat-header-cell *matHeaderCellDef> {{col.title}} </th>
          <td mat-cell *matCellDef="let element">
            {{element[col.name]}}
          </td>
        </ng-container>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="{{row.type}}" [ngClass]="{'not-staying': row.isStaying}" (click)="selection.toggle(row)"></tr>

    </table>


  </div>
  <div *ngIf="data.filter" class="filterButtons">
    <mat-button-toggle-group name="dataType" aria-label="Data Type">
      <mat-button-toggle value="all" [checked]="true" (change)="onValChange($event.value)">Vše</mat-button-toggle>
      <mat-button-toggle value="new-polozka" (change)="onValChange($event.value)">Nové</mat-button-toggle>
      <mat-button-toggle value="duplicate" (change)="onValChange($event.value)">Duplicitní</mat-button-toggle>
      <mat-button-toggle value="old-polozka" (change)="onValChange($event.value)">Staré</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div *ngIf="data.filter" class="detail">
    <div class='detail-box new-polozka'></div>
    <div class="detail-text">Nově přidané</div>
    <div class='detail-box duplicate'></div>
    <div class="detail-text">Duplicitní - Zůstavající</div>
    <div class='detail-box box-not-staying'></div>
    <div class="detail-text">Duplicitní - Přepsané</div>
    <div class='detail-box old-detail'></div>
    <div class="detail-text">Staré</div>
  </div>

  <div mat-dialog-actions>
    <button mat-button (click)="closeDialog()">Zavřít</button>
    <button mat-button (click)="confirmBtnHandle()">Potvrdit</button>
  </div>
</div>
